import React, { Component, useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect, useSelector } from "react-redux";
import {
  Box,
  Container,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import * as moderatorActions from "src/store/actions/Moderator/moderatoractions";
import * as feedActions from "src/store/actions/feedactions/feedActionCreator";
import * as SignInActions from "src/store/actions/SignInActions/SignInAction";
import "src/Assets/css/Moderator/ModeratorHeader.css";
import ModeratorHeader from "../Moderator/ModeratorHeader";
import ModeratorMenu from "./ModeratorMenu";
import EditCommunity from "./EditCommunity/EditCommunity";
import ManageMembers from "./ManageMembers/ManageMembers";
import ManageContent from "./ManageContent/ManageContent";
import NewCommunityRequest from "./NewCommunityRequest";
import Page, { PageEnum } from "src/layout/Page";
import API from "../../network";
import { withCommunity } from "src/HOC/withCommunity";
import ConfirmationDialog from "src/Components/ConfirmationDialog";

class Moderator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuItem: "1",
      subMenuItem: "Action Items",
      community: {},
      tenantId: "",
      tenantName: "",
      type: "",
      isNotificationSelected: false,
      isPm: "0",
      actionItemsCount: 0,
      unblockRequestCount: 0,
      communityRequestdata: [],
      isLoading: false,
      isAlertPopupOpen: false,
      newCommReqActionPopupMsg: "",
      showConfirmationPopup: null,
    };
  }

  setType = (value) => {
    this.setState({ type: value });
  };

  setActionItemCount = (count) => {
    this.setState({ actionItemsCount: count });
  };

  setUnblockRequestCount = (count) => {
    this.setState({ unblockRequestCount: count });
  };

  decreaseActionItemCount = () => {
    this.setState((prevState) => ({
      actionItemsCount: prevState.actionItemsCount - 1,
    }));
  };

  decreaseUnblockRequestCount = () => {
    this.setState((prevState) => ({
      unblockRequestCount: prevState.unblockRequestCount - 1,
    }));
  };

  onItemChange = (itemValue) => {
    this.setState({
      menuItem: itemValue,
    });
  };

  onCloseConfirmationPopup = () => {
    this.setState({ showConfirmationPopup: null });
  };

  handleCloseCommRequestAlert = () => {
    this.setState({ isAlertPopupOpen: false });
  };
  onSubItemChange = (subItemValue) => {
    this.setState({
      subMenuItem: subItemValue,
    });
  };

  getModeratorActionItemsAndUnblockRequestCounts = async (tenantId) => {
    // if (userDetails && Object.keys(userDetails).length !== 0) {
    if (tenantId) {
      try {
        const response = await API.getModeratorActionItems(tenantId);
        if (
          response?.data?.messageList &&
          Array.isArray(response.data.messageList)
        ) {
          this.setActionItemCount(response.data.TotalActionItems);
        }
        if (
          response?.data?.UnblockUserRequests &&
          Array.isArray(response.data.UnblockUserRequests)
        ) {
          this.setUnblockRequestCount(response.data.UnblockUserRequests.length);
        }
      } catch (e) {
        console.error(e);
      }
    }
  };

  onChangeCommunity = (community) => {
    const { tenantId, isPm, tenantName } = community || {};
    this.getModeratorActionItemsAndUnblockRequestCounts(tenantId);
    const isPrimaryModerator = String(isPm) === "1";
    // if it's not primary moderator - set menuItem to manage content
    if (!isPrimaryModerator) {
      this.setState({ tenantId, tenantName, isPm, menuItem: "1" });
    } else {
      this.setState({ tenantId, tenantName, isPm });
    }
  };

  componentDidMount() {
    // this.props.feedActions.fetchFeedData("?startlimit=0");
    this.props.SignInActions.fetchloginUser("");
    // this.props.feedActions.fetchcontirbutors("");
    this.props.feedActions.fetchSettings("");
    this.props.feedActions.fetchUserNames("@");
    this.props.moderatorActions.fetchModeratingCommunityList("");
    // this.props.moderatorActions.getTenantList();
  }

  // getTenantId = () => {
  //   return this.props.moderatingCommunitysData && this.props.moderatingCommunitysData.restrictions
  //     ? this.props.moderatingCommunitysData.restrictions[0].tenantId
  //     : this.state.tenantId;
  // };

  getTenantId = () => {
    const { tenantId } = this.state;
    // Check if tenantId is set
    if (tenantId) {
      return tenantId;
    } else if (
      this.props.moderatingCommunitysData &&
      this.props.moderatingCommunitysData.restrictions
    ) {
      // Use the first tenantId from moderatingCommunitysData if available
      return this.props.moderatingCommunitysData.restrictions[0].tenantId;
    } else {
      // Default value if neither tenantId nor moderatingCommunitysData is available
      return "";
    }
  };

  handleToggleModerator = async (isChecked, newRequestData) => {
    try {
      const tenantId = newRequestData.tenantId;
      const userId = newRequestData.createdBy;
      const pmStatus = isChecked ? "yes" : "no";

      const formData = new FormData();
      formData.append("tenantId", tenantId);
      formData.append("createdBy", userId);
      formData.append("asPM", pmStatus);

      const res = await API.newCommunityModeratorRequest(formData);

      if (res.data.status === "moderator") {
        this.setState({
          isAlertPopupOpen: true,
          newCommReqActionPopupMsg: "user approved as a moderator",
        });
      } else if (res.data.status === "NoModerator") {
        this.setState({
          isAlertPopupOpen: true,
          newCommReqActionPopupMsg: "user removed from moderator",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  onActivateNewCommunityRequest = async (id) => {
    try {
      const { communityRequestdata } = this.state;
      const formData = new FormData();
      formData.append("tid", id);
      formData.append("state", "A");
      const res = await API.approveOrRejectNewCommunityRequest(formData);
      if (res.data.status === "A") {
        const updatedCommunityRequestdata = communityRequestdata.filter(
          (item) => item.tenantId !== id
        );
        this.setState({
          communityRequestdata: updatedCommunityRequestdata,
          isAlertPopupOpen: true,
          newCommReqActionPopupMsg: "community activated successfully",
        });
      }
    } catch (error) {
      console.log(`activation error:`, error);
    }
  };

  onRemoveNewCommReq = (id) => {
    this.setState({ showConfirmationPopup: id });
  };

  handleRemoveNewCommunityRequest = async (id) => {
    try {
      const { communityRequestdata } = this.state;
      const formData = new FormData();
      formData.append("tid", id);
      formData.append("state", "AI");
      const res = await API.approveOrRejectNewCommunityRequest(formData);
      if (res.data.status === "AI") {
        this.setState({
          isAlertPopupOpen: true,
          newCommReqActionPopupMsg: "community removed successfully",
        });
        const updatedCommunityRequestdata = communityRequestdata.filter(
          (item) => item.tenantId !== id
        );
        this.setState({ communityRequestdata: updatedCommunityRequestdata });
      }
    } catch (error) {
      console.log(`Removing error:`, error);
    }
  };

  showHideNotifications = () => {
    this.setState({
      isNotificationSelected: !this.state.isNotificationSelected,
    });
  };

  fetchCommunityReqestData = async () => {
    try {
      this.setState({ isLoading: true });
      const res = await API.communityRequestData();
      this.setState({
        communityRequestdata: res?.data?.inactiveTenantLists,
        isLoading: false,
      });
    } catch (error) {
      console.error(error);
    }
  };

  onSkopicClick = async () => {
    const { settingsData, communityContext } = this.props;
    try {
      const response = await API.changeCommunity(
        settingsData?.userTenant,
        settingsData?.userTenantId
      );
      if (response) {
        communityContext?.onChangeCommunity({
          tenantId: settingsData?.userTenantId,
          tenantName: settingsData?.userTenant,
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  render() {
    const {
      isNotificationSelected,
      tenantName,
      actionItemsCount,
      unblockRequestCount,
      communityRequestdata,
      isLoading,
      showConfirmationPopup,
      newCommReqActionPopupMsg,
      isAlertPopupOpen,
      isPm,
    } = this.state;
    const { userDetails } = this.props;

    return (
      <Page page={PageEnum.Moderator} onSkopicClick={this.onSkopicClick}>
        {/* {isNotificationSelected ? (
          <div className={`col-sm-3  ${styles.notifications}`}>
            <div className={styles.notificationscroll}>
              <Notifications />
            </div>
          </div>
        ) : null} */}
        <Container sx={{ height: "115vh" }}>
          <Box sx={{ height: "115vh" }}>
            <ModeratorHeader
              menuItem={this.state.menuItem}
              onMenuItemChange={this.onItemChange}
              onChangeCommunity={this.onChangeCommunity}
              tenantId={this.state.tenantId}
              tenantName={tenantName}
              isPm={this.state.isPm}
              isAdmin={userDetails?.userData?.isAdmin}
              fetchCommunityReqestData={this.fetchCommunityReqestData}
            />
            {this.state.menuItem === "4" &&
            userDetails?.userData?.isAdmin === "1" ? (
              <NewCommunityRequest
                data={communityRequestdata}
                onToggleModerator={this.handleToggleModerator}
                onActivateNewCommunityRequest={
                  this.onActivateNewCommunityRequest
                }
                onRemoveNewCommunityRequest={this.onRemoveNewCommReq}
                isLoading={isLoading}
              />
            ) : (
              <div className="MiddleContent">
                <ModeratorMenu
                  menuItem={this.state.menuItem}
                  onSubMenuItemChange={this.onSubItemChange}
                  onTypeChange={this.setType}
                  type={this.state.type}
                  subMenuItem={this.state.subMenuItem}
                  tenantId={this.getTenantId()}
                  tenantName={tenantName}
                  actionItemsCount={actionItemsCount}
                  unblockRequestCount={unblockRequestCount}
                />
                <div className="MenuContent">
                  {this.state.menuItem === "1" ? (
                    <ManageContent
                      subMenuItem={this.state.subMenuItem}
                      tenantId={this.getTenantId()}
                      tenantName={tenantName}
                      type={this.state.type}
                      decreaseActionItemCount={this.decreaseActionItemCount}
                      decreaseUnblockRequestCount={
                        this.decreaseUnblockRequestCount
                      }
                      isPm={isPm}
                    />
                  ) : this.state.menuItem === "2" ? (
                    <ManageMembers
                      subMenuItem={this.state.subMenuItem}
                      tenantId={this.getTenantId()}
                      tenantName={tenantName}
                    />
                  ) : (
                    <EditCommunity
                      subMenuItem={this.state.subMenuItem}
                      tenantId={this.getTenantId()}
                      tenantName={tenantName}
                    />
                  )}
                </div>
              </div>
            )}
          </Box>
        </Container>
        {/* <ModeratorMenu/>
          <ModeratorContent/> */}
        {showConfirmationPopup && (
          <ConfirmationDialog
            open={true}
            handleClose={this.onCloseConfirmationPopup}
            type={"warning"}
            title={`Are you sure you want to remove this community?`}
            acceptLabel={"Yes"}
            onAccept={() => {
              this.handleRemoveNewCommunityRequest(showConfirmationPopup);
              this.onCloseConfirmationPopup();
            }}
          />
        )}
        <Dialog
          onClose={this.handleCloseCommRequestAlert}
          open={isAlertPopupOpen}
        >
          <DialogContent>
            <p>{newCommReqActionPopupMsg}</p>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseCommRequestAlert} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Page>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    SignInActions: bindActionCreators(SignInActions, dispatch),
    feedActions: bindActionCreators(feedActions, dispatch),
    moderatorActions: bindActionCreators(moderatorActions, dispatch),
  };
}

function mapStateToProps(state) {
  const { userDetails } = state.SignInReducer;
  const { moderatingCommunitysData } = state.ModeratorReducer;
  const { settingsData } = state.voteupReducer;
  return { userDetails, moderatingCommunitysData, settingsData };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withCommunity(Moderator));
